import { toaster } from 'evergreen-ui';
import asyncFetch from '../utils/asyncFetch';

const registerRequest = async ({ email, password, country, setError }) => {
  try {
    const result = await asyncFetch(`${process.env.REACT_APP_BACKEND_URL}/auth/local/register`, {
      method: 'POST',
      body: {
        password: password,
        email: email,
        username: email,
        confirmed: true,
        blocked: false,
        enabled: false,
        notificationEnabled: false,
        phoneNumber: '',
        citiesInitialized: false,
        token: '',
        userID: '',
        domain: 'grabkings',
        country,
      },
    });
    return result;
  } catch (error) {
    if (error?.data?.statusCode === 400) {
      toaster.danger('User already exists');
    } else {
      toaster.danger('Something went wrong');
    }
  }
};

export default registerRequest;
